import React from 'react';
import Joi from 'joi';
import {Select} from 'components/forms/fields';
import Section from 'components/forms/Section';
import useFieldData from 'components/forms/hooks/useFieldData';
import fields from 'components/forms/uscgaops/fields';
import {Typography} from '@material-ui/core';

const enlistedRanks = [
    'E-1',
    'E-2',
    'E-3',
    'E-4',
    'E-5',
    'E-6',
    'E-7',
    'E-8',
    'E-9',
];
const cwoRanks = ['CWO2', 'CWO3', 'CWO4'];
const officerRanks = [
    'O-1',
    'O-2',
    'O-3',
    'O-4',
    'O-5',
    'O-6',
    'O-7',
    'O-8',
    'O-9',
    'O-10',
];

const ratings = [
    'BM',
    'GM',
    'OS',
    'QM',
    'RD',
    'SM',
    'SA',
    'SN',
    'FA',
    'FN',
    'BT',
    'EM',
    'EN',
    'GS',
    'GSE',
    'GSM',
    'MK',
    'MR',
    'DC',
    'HT',
    'IC',
    'TT',
];

const schema = {
    rank_type: Joi.string().required(),
    rank_E: Joi.string().when(Joi.ref('rank_type'), {
        is: 'Enlisted',
        then: Joi.string().required(),
        otherwise: Joi.string().allow(''),
    }),
    rank_CWO: Joi.string().when(Joi.ref('rank_type'), {
        is: 'CWO',
        then: Joi.string().required(),
        otherwise: Joi.string().allow(''),
    }),
    rank_O: Joi.string().when(Joi.ref('rank_type'), {
        is: 'Commissioned Officer',
        then: Joi.string().required(),
        otherwise: Joi.string().allow(''),
    }),
    rating: Joi.string().when(Joi.ref('rank_type'), {
        switch: [
            {
                is: 'Enlisted',
                then: Joi.required(),
            },
            {
                is: 'CWO',
                then: Joi.required(),
            },
        ],
        otherwise: Joi.allow(''),
    }),
};

const initialValues = {
    rank_type: '',
    rank_E: '',
    rank_CWO: '',
    rank_O: '',
    rating: '',
};

const RankRating = props => {
    const [type, setType] = useFieldData('rank_type', 'Enlisted');
    const updateType = e => {
        setType(e.target.value);
    };

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Rank and Rating
            </Typography>
            <Typography variant='body1'>
                Start by entering your rating/rank that is listed on this AOPS.
            </Typography>
            <Select
                required
                name={fields.rank_type.name}
                label={fields.rank_type.label}
                onChange={updateType}
                options={{
                    Enlisted: 'Enlisted',
                    CWO: 'CWO',
                    'Commissioned Officer': 'Commissioned Officer',
                }}
            />
            {type === 'Enlisted' ? (
                <Select
                    required
                    name={fields.rank_E.name}
                    label={fields.rank_E.label}
                    options={enlistedRanks}
                />
            ) : null}
            {type === 'CWO' ? (
                <Select
                    required
                    name={fields.rank_CWO.name}
                    label={fields.rank_CWO.label}
                    options={cwoRanks}
                />
            ) : null}
            {type === 'Commissioned Officer' ? (
                <Select
                    required
                    name={fields.rank_O.name}
                    label={fields.rank_O.label}
                    options={officerRanks}
                />
            ) : null}
            {type === 'Enlisted' || type === 'CWO' ? (
                // Update to select once ratings disambiguated
                <Select
                    required
                    name={fields.rating.name}
                    label={fields.rating.label}
                    options={ratings}
                />
            ) : null}
            {props.children}
        </Section>
    );
};

export default RankRating;
